(function () {
  "use strict";

  var VEHICLE_KEY = "nreSelectedVehicle";
  var vehicleCatalog;

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function debounce(callback, delay) {
    var timer;
    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        callback.apply(null, args);
      }, delay);
    };
  }

  function readVehicleCatalog() {
    if (vehicleCatalog) return vehicleCatalog;
    var dataNode = document.querySelector("[data-nre-global-vehicle-data]");
    if (!dataNode) return null;
    try {
      vehicleCatalog = JSON.parse(dataNode.textContent);
      var fitmentsNode = document.querySelector("[data-nre-category-fitments]");
      vehicleCatalog.categoryFitments = fitmentsNode ? JSON.parse(fitmentsNode.textContent) : {};
      return vehicleCatalog;
    } catch (error) {
      return null;
    }
  }

  function findGeneration(catalog, value) {
    if (!catalog || !value) return null;
    var match = null;
    Object.keys(catalog.generations || {}).some(function (makeValue) {
      var generation = (catalog.generations[makeValue] || []).find(function (option) {
        return option.value === value;
      });
      if (!generation) return false;
      match = {
        make: (catalog.makes || []).find(function (option) { return option.value === makeValue; }),
        generation: generation
      };
      return true;
    });
    return match;
  }

  function categoryForValue(catalog, value) {
    return (catalog.categories || []).find(function (option) { return option.value === value; }) ||
      { label: "All parts", value: "all" };
  }

  function syncVehicleFromPath() {
    var catalog = readVehicleCatalog();
    if (!catalog) return readVehicle();
    var segments = window.location.pathname.split("/").filter(Boolean).map(function (segment) {
      try { return decodeURIComponent(segment); } catch (error) { return segment; }
    });
    var match;
    segments.some(function (segment) {
      match = findGeneration(catalog, segment);
      return Boolean(match);
    });
    if (!match || !match.make) return readVehicle();

    var collectionIndex = segments.indexOf("collections");
    var categoryValue = collectionIndex >= 0 ? segments[collectionIndex + 1] : "all";
    if (categoryValue === match.generation.value) categoryValue = "all";
    if (new URLSearchParams(window.location.search).get("view") === "solution-kits") {
      categoryValue = "solution-kits";
    }
    var vehicle = {
      make: match.make,
      generation: match.generation,
      category: categoryForValue(catalog, categoryValue)
    };
    writeVehicle(vehicle);
    return vehicle;
  }

  function categoryIsAvailable(catalog, vehicle, categoryValue) {
    if (!vehicle || !vehicle.generation || categoryValue === "all") return true;
    var fitments = (catalog.categoryFitments || {})[categoryValue];
    return Array.isArray(fitments) && fitments.indexOf(vehicle.generation.value) !== -1;
  }

  function categoryUrl(categoryValue, vehicle) {
    var generation = vehicle && vehicle.generation && vehicle.generation.value;
    if (categoryValue === "solution-kits") {
      return "/collections/all-in-one-kits" +
        (generation ? "/" + generation : "") + "?view=solution-kits";
    }
    return "/collections/" + categoryValue + (generation ? "/" + generation : "");
  }

  function readVehicle() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(VEHICLE_KEY) || "null");
      var catalog = readVehicleCatalog();
      var match = saved && saved.generation && findGeneration(catalog, saved.generation.value);
      if (match) saved.generation = match.generation;
      return saved;
    } catch (error) {
      return null;
    }
  }

  function writeVehicle(vehicle) {
    try {
      window.localStorage.setItem(VEHICLE_KEY, JSON.stringify(vehicle));
    } catch (error) {
      return;
    }
  }

  function clearVehicle() {
    try {
      window.localStorage.removeItem(VEHICLE_KEY);
    } catch (error) {
      return;
    }
    updateVehicleDisplays(null);
    document.dispatchEvent(new CustomEvent("nre:vehicle-cleared"));
  }

  function updateVehicleDisplays(vehicle) {
    var catalog = readVehicleCatalog();
    if (vehicle && vehicle.generation &&
        new URLSearchParams(window.location.search).get("view") === "solution-kits") {
      vehicle = JSON.parse(JSON.stringify(vehicle));
      if (vehicle.generation.value === "2019-2022-6-7l-cummins") {
        vehicle.generation.label = "2019-2021 6.7L Cummins";
      } else if (vehicle.generation.value === "2007-5-2018-6-7l-cummins") {
        vehicle.generation.label = "2010-2018 6.7L Cummins";
      }
    }
    all("[data-nre-vehicle-chip]").forEach(function (chip) {
      var label = chip.querySelector("[data-nre-vehicle-chip-label]");
      if (vehicle && vehicle.generation && vehicle.generation.label) {
        chip.setAttribute("data-active", "true");
        if (label) label.textContent = vehicle.generation.label;
      } else {
        chip.removeAttribute("data-active");
        if (label) label.textContent = "";
      }
    });

    all("[data-nre-selected-vehicle]").forEach(function (banner) {
      var label = banner.querySelector("[data-nre-selected-vehicle-label]");
      if (vehicle && vehicle.generation && vehicle.generation.label) {
        banner.setAttribute("data-active", "true");
        if (label) label.textContent = vehicle.generation.label;
      } else {
        banner.removeAttribute("data-active");
      }
    });

    all("[data-nre-category-link]").forEach(function (link) {
      var collection = link.getAttribute("data-nre-category-link") || "all";
      var available;
      link.href = categoryUrl(collection, vehicle);
      available = categoryIsAvailable(catalog || {}, vehicle, collection);
      link.hidden = !available;
      if (link.parentElement && link.parentElement.tagName === "LI") link.parentElement.hidden = !available;
    });
  }

  function initHeaderMenus() {
    var items = all("[data-nre-nav-item]");

    function closeMenus(except) {
      items.forEach(function (item) {
        if (item !== except) {
          item.removeAttribute("data-open");
          var toggle = item.querySelector("[data-nre-nav-toggle]");
          if (toggle) toggle.setAttribute("aria-expanded", "false");
        }
      });
    }

    items.forEach(function (item) {
      var toggle = item.querySelector("[data-nre-nav-toggle]");
      if (!toggle) return;
      toggle.addEventListener("click", function () {
        var opening = item.getAttribute("data-open") !== "true";
        closeMenus(item);
        if (opening) {
          item.setAttribute("data-open", "true");
          toggle.setAttribute("aria-expanded", "true");
        } else {
          item.removeAttribute("data-open");
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!event.target.closest("[data-nre-nav-item]")) closeMenus();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeMenus();
    });
  }

  function initMobileMenu() {
    var drawer = document.querySelector("[data-nre-mobile-drawer]");
    var backdrop = document.querySelector("[data-nre-mobile-backdrop]");
    var openButton = document.querySelector("[data-nre-mobile-open]");
    var closeButton = document.querySelector("[data-nre-mobile-close]");
    if (!drawer || !backdrop || !openButton || !closeButton) return;

    function setOpen(open) {
      drawer.setAttribute("data-open", open ? "true" : "false");
      backdrop.setAttribute("data-open", open ? "true" : "false");
      openButton.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("nre-menu-open", open);
      if (open) closeButton.focus();
    }

    openButton.addEventListener("click", function () { setOpen(true); });
    closeButton.addEventListener("click", function () { setOpen(false); });
    backdrop.addEventListener("click", function () { setOpen(false); });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.getAttribute("data-open") === "true") {
        setOpen(false);
        openButton.focus();
      }
    });
  }

  function initPredictiveSearch() {
    all("[data-nre-predictive-search]").forEach(function (form) {
      var input = form.querySelector("input[type='search']");
      var results = form.querySelector("[data-nre-predictive-results]");
      var activeRequest = 0;
      if (!input || !results) return;

      function close() {
        form.removeAttribute("data-open");
        input.setAttribute("aria-expanded", "false");
      }

      function open() {
        form.setAttribute("data-open", "true");
        input.setAttribute("aria-expanded", "true");
      }

      var search = debounce(function () {
        var query = input.value.trim();
        if (query.length < 2) {
          results.innerHTML = "";
          close();
          return;
        }

        var requestId = ++activeRequest;
        results.innerHTML = '<div class="nre-predictive__empty">Searching...</div>';
        open();
        window.fetch("/search?view=nre-predictive&type=product&q=" + encodeURIComponent(query), {
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(function (response) {
          if (!response.ok) throw new Error("Search request failed");
          return response.text();
        }).then(function (html) {
          if (requestId !== activeRequest) return;
          results.innerHTML = html;
          open();
        }).catch(function () {
          if (requestId !== activeRequest) return;
          results.innerHTML = '<a class="nre-predictive__footer" href="/search?type=product&q=' + encodeURIComponent(query) + '">View search results</a>';
          open();
        });
      }, 180);

      input.addEventListener("input", search);
      input.addEventListener("focus", function () {
        if (results.innerHTML.trim() && input.value.trim().length >= 2) open();
      });
      input.addEventListener("keydown", function (event) {
        if (event.key === "Escape") close();
      });
      document.addEventListener("click", function (event) {
        if (!form.contains(event.target)) close();
      });
    });
  }

  function initVehicleFinders() {
    all("[data-nre-vehicle-finder]").forEach(function (form) {
      var data = readVehicleCatalog();
      if (!data) return;

      var saved = readVehicle();
      var state = {
        make: saved && saved.make ? saved.make : null,
        generation: saved && saved.generation ? saved.generation : null,
        category: saved && saved.category ? saved.category : { label: "All parts", value: "all" }
      };
      var combos = {};

      all("[data-nre-combobox]", form).forEach(function (combo) {
        var kind = combo.getAttribute("data-nre-combobox");
        combos[kind] = {
          root: combo,
          button: combo.querySelector(".nre-combobox__button"),
          label: combo.querySelector(".nre-combobox__button span"),
          search: combo.querySelector(".nre-combobox__search"),
          options: combo.querySelector(".nre-combobox__options")
        };
      });

      function optionsFor(kind) {
        if (kind === "make") return data.makes;
        if (kind === "generation") return state.make ? (data.generations[state.make.value] || []) : [];
        return (data.categories || []).filter(function (option) {
          return categoryIsAvailable(data, state, option.value);
        });
      }

      function closeCombos(except) {
        Object.keys(combos).forEach(function (key) {
          var combo = combos[key];
          if (combo.root !== except) {
            combo.root.removeAttribute("data-open");
            combo.button.setAttribute("aria-expanded", "false");
          }
        });
      }

      function selectedFor(kind) {
        return state[kind];
      }

      function render(kind, filter) {
        var combo = combos[kind];
        var selected = selectedFor(kind);
        var normalized = (filter || "").toLowerCase();
        var choices = optionsFor(kind).filter(function (option) {
          return option.label.toLowerCase().indexOf(normalized) !== -1;
        });

        combo.options.innerHTML = "";
        if (!choices.length) {
          combo.options.innerHTML = '<div class="nre-combobox__empty">No matches found</div>';
          return;
        }

        choices.forEach(function (option) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "nre-combobox__option";
          button.setAttribute("role", "option");
          button.setAttribute("aria-selected", selected && selected.value === option.value ? "true" : "false");
          button.textContent = option.label;
          button.addEventListener("click", function () {
            state[kind] = option;
            if (kind === "make") {
              state.generation = null;
              state.category = { label: "All parts", value: "all" };
            }
            if (kind === "generation") state.category = { label: "All parts", value: "all" };
            updateControls();
            combo.root.removeAttribute("data-open");
            combo.button.setAttribute("aria-expanded", "false");
            combo.button.focus();
          });
          combo.options.appendChild(button);
        });
      }

      function updateControls() {
        if (state.category && !categoryIsAvailable(data, state, state.category.value)) {
          state.category = { label: "All parts", value: "all" };
        }
        ["make", "generation", "category"].forEach(function (kind) {
          var combo = combos[kind];
          var selected = selectedFor(kind);
          combo.label.textContent = selected ? selected.label : combo.button.getAttribute("data-placeholder");
        });
        combos.generation.button.disabled = !state.make;
        combos.category.button.disabled = !state.generation;
      }

      Object.keys(combos).forEach(function (kind) {
        var combo = combos[kind];
        combo.button.addEventListener("click", function () {
          if (combo.button.disabled) return;
          var opening = combo.root.getAttribute("data-open") !== "true";
          closeCombos(combo.root);
          if (opening) {
            combo.root.setAttribute("data-open", "true");
            combo.button.setAttribute("aria-expanded", "true");
            combo.search.value = "";
            render(kind, "");
            window.setTimeout(function () { combo.search.focus(); }, 0);
          } else {
            combo.root.removeAttribute("data-open");
            combo.button.setAttribute("aria-expanded", "false");
          }
        });
        combo.search.addEventListener("input", function () { render(kind, combo.search.value); });
        combo.search.addEventListener("keydown", function (event) {
          if (event.key === "Escape") {
            combo.root.removeAttribute("data-open");
            combo.button.setAttribute("aria-expanded", "false");
            combo.button.focus();
          }
        });
      });

      document.addEventListener("click", function (event) {
        if (!form.contains(event.target)) closeCombos();
      });

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        if (!state.make) {
          combos.make.button.focus();
          combos.make.button.click();
          return;
        }
        if (!state.generation) {
          combos.generation.button.focus();
          combos.generation.button.click();
          return;
        }
        if (!state.category) state.category = { label: "All parts", value: "all" };
        writeVehicle(state);
        updateVehicleDisplays(state);
        window.location.href = categoryUrl(state.category.value, state);
      });

      document.addEventListener("nre:vehicle-cleared", function () {
        state.make = null;
        state.generation = null;
        state.category = { label: "All parts", value: "all" };
        closeCombos();
        updateControls();
      });

      updateControls();
    });

    all("[data-nre-clear-vehicle]").forEach(function (button) {
      button.addEventListener("click", function () {
        var clearUrl = button.getAttribute("data-nre-clear-vehicle-url");
        clearVehicle();
        if (clearUrl) window.location.href = clearUrl;
      });
    });
    updateVehicleDisplays(readVehicle());
  }

  function initSortControls() {
    all("[data-nre-sort]").forEach(function (select) {
      var defaultSort = select.getAttribute("data-nre-default-sort");
      var currentUrl = new URL(window.location.href);
      if (defaultSort && !currentUrl.searchParams.has("sort_by") && select.querySelector('option[value="' + defaultSort + '"]')) {
        currentUrl.searchParams.set("sort_by", defaultSort);
        window.location.replace(currentUrl.toString());
        return;
      }
      select.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", select.value);
        window.location.href = url.toString();
      });
    });
  }

  function initHeroSlideshows() {
    all("[data-nre-hero]").forEach(function (hero) {
      var slides = all("[data-nre-hero-slide]", hero);
      var dots = all("[data-nre-hero-dot]", hero);
      var previous = hero.querySelector("[data-nre-hero-previous]");
      var next = hero.querySelector("[data-nre-hero-next]");
      var pause = hero.querySelector("[data-nre-hero-pause]");
      var autoplay = hero.getAttribute("data-nre-hero-autoplay") === "true";
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var speed = parseInt(hero.getAttribute("data-nre-hero-speed"), 10) || 6000;
      var current = 0;
      var timer = null;
      var paused = false;
      var touchStartX = null;

      if (slides.length < 2) return;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.setAttribute("data-active", slideIndex === current ? "true" : "false");
        });
        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute("data-active", dotIndex === current ? "true" : "false");
          dot.setAttribute("aria-current", dotIndex === current ? "true" : "false");
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!autoplay || reduceMotion || paused || document.hidden) return;
        timer = window.setInterval(function () { show(current + 1); }, speed);
      }

      function select(index) {
        show(index);
        start();
      }

      if (previous) previous.addEventListener("click", function () { select(current - 1); });
      if (next) next.addEventListener("click", function () { select(current + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener("click", function () { select(index); });
      });
      if (pause) {
        pause.addEventListener("click", function () {
          paused = !paused;
          pause.setAttribute("aria-label", paused ? "Play slideshow" : "Pause slideshow");
          pause.querySelector("span").textContent = paused ? "▶" : "Ⅱ";
          start();
        });
      }

      hero.addEventListener("touchstart", function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      hero.addEventListener("touchend", function (event) {
        if (touchStartX === null) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 50) return;
        select(distance > 0 ? current - 1 : current + 1);
      }, { passive: true });
      document.addEventListener("visibilitychange", start);

      show(0);
      start();
    });
  }

  function initMobileCart() {
    var sticky = document.querySelector("[data-nre-mobile-cart]");
    var primary = document.querySelector("[id^='AddToCart-']");
    var stickyButton = sticky && sticky.querySelector("button");
    var primaryPrice = document.querySelector("[id^='ProductPrice-']");
    var stickyPrice = sticky && sticky.querySelector("[data-nre-mobile-price]");
    var appPrice = document.querySelector("[data-nre-app-price]");
    var basePrice = document.querySelector("[data-nre-base-price]");
    if (!sticky || !primary || !stickyButton) return;

    function sync() {
      stickyButton.disabled = primary.disabled;
      stickyButton.textContent = primary.textContent.trim();
      var bundlePrice = appPrice && (
        appPrice.querySelector(".price-item--sale") ||
        appPrice.querySelector(".price-item--regular")
      );
      var hasBundlePrice = Boolean(bundlePrice && bundlePrice.textContent.trim());
      // Keep the theme price as a fallback when the app block is absent or fails to render.
      if (basePrice) basePrice.hidden = hasBundlePrice;
      var displayedPrice = hasBundlePrice ? bundlePrice : primaryPrice;
      if (displayedPrice && stickyPrice) {
        var text = displayedPrice.textContent.trim();
        if (stickyPrice.textContent !== text) stickyPrice.textContent = text;
      }
    }

    stickyButton.addEventListener("click", function () { primary.click(); });
    var observer = new MutationObserver(sync);
    observer.observe(primary, { attributes: true, childList: true, subtree: true });
    if (primaryPrice) observer.observe(primaryPrice, { childList: true, subtree: true });
    if (appPrice) observer.observe(appPrice, { childList: true, subtree: true, characterData: true });
    sync();
  }

  ready(function () {
    syncVehicleFromPath();
    initHeaderMenus();
    initMobileMenu();
    initPredictiveSearch();
    initVehicleFinders();
    initSortControls();
    initHeroSlideshows();
    initMobileCart();
  });
})();
